var config = {
    Promise: undefined};

export { config };
//# sourceMappingURL=config.js.map
